<template>
    <div>
        <SimpleTable formclass="pages/OCPI/form" endpoint="api/v2/ocpi" :aditionalColumns="headers" @saveItem="forceSyncServer" inlineToggle>
            <template v-slot>
                <h1>OCPI</h1>
                <v-divider class="mb-4" />
                <v-alert icon="info" prominent text type="info">
                    Gerencie as configurações OCPI e seus servidores associados. <br><br>

                    Forçar o carregamento das configurações nos servidores:

                    <div v-if="servers && servers.length > 0">
                        <v-btn v-for="server in servers" :key="server" @click="syncServer(server)" color="info" small class="ma-1">
                            <v-icon small left>sync</v-icon>
                            {{ server }}
                        </v-btn>
                    </div>
                </v-alert>

            </template>

            <!-- Template para mostrar quantidade de servidores -->
            <template v-slot:extra-column="item">
                <v-chip v-if="item.partnerServer && item.partnerServer.url" color="primary" text-color="white" small>
                    <v-icon small left>dns</v-icon>
                    Cliente
                </v-chip>

                <v-chip v-if="item.api && item.api.token" color="success" text-color="white" small class="ml-1">
                    <v-icon small left>vpn_key</v-icon>
                    API
                </v-chip>
            </template>

            <template v-slot:more-extra-column="item">
                <v-chip v-if="item.chargers && item.chargers.length > 0" color="success" text-color="white" small>
                    <v-icon small left>ev_station</v-icon>
                    {{ item.chargers.length }}
                </v-chip>
                <v-chip v-else color="grey" text-color="white" small>
                    <v-icon small left>ev_station</v-icon>
                    0
                </v-chip>

            </template>
        </SimpleTable>
        <ConfirmModal ref="confirm" />
    </div>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
import ConfirmModal from "@/components/core/ConfirmModal";
import servers from "@/assets/json/servers.json";

export default {
    components: { SimpleTable, ConfirmModal },

    data() {
        return {
            servers,
            headers: [
                { text: "Habilitado", value: "enable", align: "right", sortable: false },
                // { text: "Ações", value: "actions-column", align: "center", sortable: false },
                { text: "Servidores", value: "extra-column", align: "center", sortable: false },
                { text: "Carregadores", value: "more-extra-column", align: "center", sortable: false },
                { text: "Nome", value: "name", align: "right", sortable: true },
            ],
        };
    },

    methods: {
        forceSyncServer(item) {
            if (item && item.server) {
                this.syncServer(item.server);
            }
        },
        syncServer(server) {
            if (server) {
                this.$refs.confirm
                    .open("Tem certeza?", "Deseja forçar o carregamento das configurações? \n\n Isso forçará a atualização das configurações de OCPI no servidor, mesmo que não haja alterações.")
                    .then((confirm) => {
                        if (confirm) {
                            this.$http
                                .postDynamic(server, "api/v2/ocpi/reload", {})
                                .then(() => {
                                    this.$eventHub.$emit("msgSuccess", "Solicitação de sincronização enviada com sucesso.");
                                }).catch((error) => {
                                    this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao enviar, tente novamente.");
                                });
                        }
                    });
            } else {
                this.$eventHub.$emit("msgError", "Falta configuração do servidor.");
            }
        },
    },
};
</script>